<div
  class="meeting-row"
  [class.meeting-row--busy]="ocupada()"
  [class.meeting-row--live]="aoVivo()"
  role="link"
  tabindex="0"
  [attr.aria-label]="'Abrir a meeting ' + title()"
  (click)="abrir.emit(meeting())"
  (keydown.enter)="abrir.emit(meeting())">
  <span class="meeting-row__avatar" aria-hidden="true">{{ iniciais() }}</span>

  <div class="meeting-row__main">
    <div class="meeting-row__title-line">
      <span class="meeting-row__title" [title]="title()">{{ title() }}</span>
      @if (renamedBy(); as renamed) {
        <!-- Card 3803: título dado por uma pessoa (o original fica na linha de apoio). -->
        <i class="pi pi-pencil meeting-row__renamed" [title]="renamed" aria-hidden="true"></i>
      }
      @if (privateTooltip(); as tooltip) {
        <span class="meeting-row__private" [title]="tooltip">
          <i class="pi pi-lock" aria-hidden="true"></i> Privada
        </span>
      }
      @if (tipo(); as t) {
        <!-- Tipo da reunião classificado pelo Cog: aparece sempre que existir. -->
        <span
          [class]="'meeting-row__type meeting-row__type--' + tomDoTipo()"
          title="Tipo da reunião, classificado pelo Cog">
          {{ t }}
        </span>
      }
      @if (meeting().isShared) {
        <span
          class="meeting-row__access"
          [title]="
            meeting().sharedByName
              ? 'Disponibilizada para acesso geral por ' + meeting().sharedByName
              : 'Disponibilizada para acesso geral'
          ">
          <i class="pi pi-globe" aria-hidden="true"></i> Acesso geral
        </span>
      }
      @if (archivedOn(); as archivedAt) {
        <!-- Card 3786: arquivada só aparece na aba Arquivadas, onde o menu oferece Restaurar. -->
        <span class="meeting-row__archived" [title]="'Arquivada em ' + archivedAt">
          <i class="pi pi-inbox" aria-hidden="true"></i> Arquivada
        </span>
      }
      @if (remarcadaPara(); as quando) {
        <!-- Card 3191: o calendário mudou o horário; a reunião que vale é a do horário novo. -->
        <span class="meeting-row__rescheduled" [title]="'A reunião foi remarcada para ' + quando">
          <i class="pi pi-calendar-clock" aria-hidden="true"></i> Remarcada para {{ quando }}
        </span>
      }
    </div>
    @if (meeting().shortDescription; as description) {
      <!-- Card 3803: descrição curta do Cog. -->
      <span class="meeting-row__description" [title]="description">{{ description }}</span>
    }
    <!-- O trecho "na agenda de …" (card 3236) pode passar da largura: o title mostra a linha inteira. -->
    <span class="meeting-row__meta" [title]="supportLine()">{{ supportLine() }}</span>
  </div>

  <div class="meeting-row__orgs">
    @for (chip of chipsVisiveis(); track chip.nome + chip.icone) {
      <span class="meeting-row__chip" [title]="chip.nome">
        <i [class]="chip.icone" aria-hidden="true"></i>
        <span class="meeting-row__chip-text">{{ chip.nome }}</span>
      </span>
    }
    @if (chipsOcultos().length) {
      <span class="meeting-row__chip meeting-row__chip--more" [title]="nomesOcultos()">
        +{{ chipsOcultos().length }}
      </span>
    }
  </div>

  <div class="meeting-row__deal">
    @if (deal(); as link) {
      <span class="meeting-row__deal-link" [title]="rotuloDoDeal(link)">
        <i class="pi pi-briefcase" aria-hidden="true"></i>
        <span class="meeting-row__deal-text">{{ rotuloDoDeal(link) }}</span>
        @if (outrosDeals()) {
          <span class="meeting-row__deal-more">+{{ outrosDeals() }}</span>
        }
      </span>
    } @else {
      <button
        type="button"
        class="meeting-row__link-deal"
        [disabled]="ocupada()"
        (keydown.enter)="$event.stopPropagation()"
        [title]="'Vincular empresa, parceiro, deal ou relacionamento bancário'"
        (click)="$event.stopPropagation(); vincular.emit(meeting())">
        <i class="pi pi-link" aria-hidden="true"></i> Vínculos
      </button>
    }
  </div>

  <!-- A célula existe em todas as abas: sem ela o grid desloca as colunas seguintes. -->
  <div class="meeting-row__bot">
    @if (ehProximas()) {
      <div
        [title]="
          botAlteravel()
            ? botLigado()
              ? 'Desligar: o bot não entra nesta reunião'
              : 'Ligar: o bot entra e grava esta reunião'
            : 'Não dá para mudar o bot desta reunião agora'
        "
        (click)="$event.stopPropagation()"
        (keydown.enter)="$event.stopPropagation()">
        @for (v of [versaoDoToggle()]; track v) {
          <app-switch
            [label]="'Bot'"
            [checked]="botLigado()"
            [disabled]="ocupada() || !botAlteravel()"
            (sendChecked)="aoAlternarBot($event)" />
        }
      </div>
    }
  </div>

  <!-- Card 3803: coluna "Quem vê" (Time, Parceiro, Cliente), estado e motivo vindos do backend. -->
  <div class="meeting-row__visibility">
    @if (showVisibilityLabel()) {
      <!-- A lista não tem cabeçalho de colunas: o rótulo vai na primeira linha de cada período. -->
      <span class="meeting-row__visibility-label">Quem vê</span>
    }
    <app-meeting-visibility-icons [visibility]="meeting().visibility" />
  </div>

  <div class="meeting-row__status">
    @if (ehProximas()) {
      <app-meeting-status-tag
        [status]="meeting().status"
        [label]="situacaoProxima().rotulo"
        [tone]="situacaoProxima().tom" />
    } @else {
      <app-meeting-status-tag [status]="meeting().status" />
    }
  </div>

  <div
    class="meeting-row__menu"
    (click)="$event.stopPropagation()"
    (keydown.enter)="$event.stopPropagation()">
    @if (!ocupada()) {
      <app-action-menu [items]="acoes()" />
    }
  </div>
</div>
